class exports.Form extends KoModel

    constructor: (handler, data) ->
        super()

        self = this

        @question = ko.observable ''
        @options = ko.observableArray []
        @nominationsAllowed = ko.observable false

        @allowNominations = () =>
            @options []
            @nominationsAllowed(true)

        @disallowNominations = () =>
            @nominationsAllowed(false)

        @addOption = () =>
            @options.push
                text: ko.observable ''

        @removeOption = () ->
            self.options.remove this

        @addOption()
